import { useMemo } from 'react';
import useSWR from 'swr';
import api from '../../services/api';
import { deduplicar } from './helpers';

const fetcher = url => api.get(url).then(res => res.data);

export default function useListagemTab({
  ativo,
  dataInicial,
  dataFinal,
  convenios,
  procedimentos,
}) {
  const swrKey =
    ativo && dataInicial && dataFinal
      ? `fechamento/guia?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
      : null;

  const { data, error, isLoading, mutate } = useSWR(swrKey, fetcher, {
    revalidateOnFocus: false,
  });

  const dadosFiltrados = useMemo(() => {
    const unicos = deduplicar(data);
    return unicos.filter(item => {
      const convOk = convenios.length === 0 || convenios.includes(item.CODCONV);
      const procOk =
        procedimentos.length === 0 || procedimentos.includes(item.CODPROCEDI);
      return convOk && procOk;
    });
  }, [data, convenios, procedimentos]);

  return { dados: dadosFiltrados, error, isLoading, mutate };
}
